// extracted by mini-css-extract-plugin
export default {"gif":"l_bk","gif--wrapped":"l_bl"};